import api from 'api/direct-mail';
import handleResponse from './utils/handleResponse';

export const getSendOrderOptions = () => {
    return handleResponse(
        api().get('/corporate/send-order/get')
    );
}